import cn from 'classnames';

import styles from './Radio.module.scss';
import { RadioProps, RadioVariant } from './types';

const variantClass: Record<RadioVariant, string> = {
    icon: styles.radio_variant_icon,
    row: styles.radio_variant_row,
    rowRing: styles.radio_variant_rowRing,
};

export const Radio = ({
    checked = false,
    disabled = false,
    error = false,
    label,
    variant = 'row',
    className,
    type = 'button',
    ...props
}: RadioProps) => (
    <button
        type={type}
        className={cn(
            styles.radio,
            variantClass[variant],
            checked && styles.radio_checked,
            disabled && styles.radio_disabled,
            error && styles.radio_error,
            className
        )}
        aria-checked={checked}
        role="radio"
        disabled={disabled}
        {...props}
    >
        <div className={styles.radio_indicatorWrap} aria-hidden>
            <svg className={styles.radio_indicator} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <circle className={styles.radio_outerRing} cx="12" cy="12" r="11" />
                <circle className={styles.radio_innerCircle} cx="12" cy="12" r="9" />
                <circle className={styles.radio_dot} cx="12" cy="12" r="6" />
            </svg>
        </div>
        {label ? <span className={styles.radio_label}>{label}</span> : null}
    </button>
);
